<template>
  <div
    v-if="operation.minimums && operation.minimums.length > 0 && operation.minimum_type == 'category'"
    class="col-12 col-lg-6 d-flex flex-column p-3"
  >
    <OperationsTitle name="Minimums" />
    <div v-for="minimum in operation.minimums" :key="minimum.id" class="row mb-2">
      <div class="col-2">
        <i class="bushel-icon bushel-2x" :class="categoryIcon(minimum.category.name)" />
      </div>
      <div class="col-8">
        <p class="text-nowrap mb-0 mt-1">
          {{ minimum.category.short_display_name }} <span v-if="minimum.price">/ {{ currency(minimum.price) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import OperationsTitle from "../common/OperationsTitle.vue";
import { categoryIcon } from "@/services/applicationSpecificHelpers";
import { currency } from "@/services/filters";

export default {
  name: "OperationsMinimums",
  components: {
    OperationsTitle,
  },
  props: {
    operation: { type: Object, requred: true },
  },
  methods: {
    currency,
    categoryIcon,
  },
};
</script>

<style scoped></style>
